import {
    createUnknownComponentVNode as _$cc,
    createVNode as _$cv,
    className as _$cn,
    createElementVNode as _$ce,
    noop as _$no,
    map as _$ma,
} from 'intact';
import {TransitionGroup, Transition} from 'intact';
import {Input} from '../input';
import {Icon} from '../icon';
import {isNullOrUndefined, isStringOrNumber} from 'intact-shared';
import makeStyles from './styles';
import {Dropdown} from '../dropdown';
import {getRestProps, addStyle} from '../utils';
import {Wave} from '../wave';
import {context as ErrorContext} from '../form/useError';

var _$tmp0 = {
    'className': 'ion-load-c',
    'rotate': true
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    var _$blocks = {};
    var __$blocks = {};
    
    const {
        value, multiple,
        loading, disabled, name,
        size, hideIcon, fluid,
        clearable, filterable,
        className, container,
        inline, style, width,
    
        _show,
    } = this.get();
    
    const classNameObj = {
        'k-select': true,
        'k-disabled': disabled,
        [`k-${size}`]: size !== 'default',
        'k-fluid': fluid,
        'k-inline': inline,
        [className]: className,
        [$props.className]: $props.className,
        [makeStyles()]: true,
    };
    
    const placeholder = this.getPlaceholder();
    const label = this.getLabel();
    const hasValue = this.hasValue();
    const {onInput, inputRef, keywords: {value: keywords}} = this.input;
    const {onFocusout, triggerRef} = this.focusout;
    
    return _$cc(ErrorContext.Consumer, {
        'defaultValue': false,
        'children': isInvalid => {
            return _$cc(Wave, {
                'disabled': disabled || isInvalid || inline,
                'inset': '-2px',
                'children': (
                    _$cc(Dropdown, {
                        'trigger': 'click',
                        'ref': this.dropdownRef,
                        'disabled': disabled,
                        'container': container,
                        'children': [
                            _$cv('div', {
                                ...getRestProps(this),
                                'className': _$cn(classNameObj),
                                'tabindex': disabled ? '-1' : '0',
                                'ev-keydown': this.onKeydown,
                                'ev-focusout': onFocusout,
                                'style': !isNullOrUndefined(width) ? addStyle(style, {width: `${width}px`}) : style,
                                'ref': triggerRef
                            }, [
                                ($blocks.prefix) ?
                                    _$ce(2, 'div', (
                                        (
                                            (_$blocks['prefix'] = function($super) {
                                                return null;
                                            }),
                                            (__$blocks['prefix'] = function($super, data) {
                                                var block = $blocks['prefix'];
                                                var callBlock = function() {
                                                    return _$blocks['prefix'].call($this, $super, data);
                                                };
                                                return block ?
                                                    block.call($this, callBlock, data) :
                                                    callBlock();
                                            }),
                                            __$blocks['prefix'](_$no)
                                        )
                                    ), 0, 'k-select-prefix') :
                                    undefined,
                                _$ce(2, 'div', [
                                    _$ce(64, 'input', null, 1, null, {
                                        'type': 'hidden',
                                        'value': value,
                                        'name': name
                                    }, 'hidden-input'),
                                    null,
                                    _$cc(TransitionGroup, {
                                        'name': 'k-fade',
                                        'appear': false,
                                        'children': (
                                            (!multiple && filterable) ?
                                                _$cc(Input, {
                                                    'value': _show ? keywords : label,
                                                    'ev-$change:value': onInput,
                                                    'disabled': disabled,
                                                    'placeholder': label || placeholder,
                                                    'ref': inputRef,
                                                    'size': size,
                                                    'fluid': true,
                                                    'inline': true,
                                                    'key': 'input',
                                                    'readonly': !_show,
                                                    'waveDisabled': true
                                                }, 'input', inputRef) :
                                                !filterable && !hasValue ?
                                                    _$ce(2, 'div', placeholder, 0, 'k-select-placeholder c-ellipsis', null, 'placeholder') :
                                                    !multiple ?
                                                        _$ce(2, 'div', (
                                                            (
                                                                (_$blocks['value'] = function($super) {
                                                                    return label;
                                                                }),
                                                                (__$blocks['value'] = function($super, data) {
                                                                    var block = $blocks['value'];
                                                                    var callBlock = function() {
                                                                        return _$blocks['value'].call($this, $super, data);
                                                                    };
                                                                    return block ?
                                                                        block.call($this, callBlock, data) :
                                                                        callBlock();
                                                                }),
                                                                __$blocks['value'](_$no, [value, label])
                                                            )
                                                        ), 0, 'k-select-value c-ellipsis', null, 'value') :
                                                        _$ce(2, 'div', [
                                                            _$cc(TransitionGroup, {
                                                                'name': 'k-fade',
                                                                'children': (
                                                                    (
                                                                        (
                                                                            (_$blocks['values'] = function($super) {
                                                                                return (
                                                                                    _$ma(label, function($label, $key) {
                                                                                        return _$ce(2, 'div', [
                                                                                            _$ce(2, 'span', (
                                                                                                (
                                                                                                    (_$blocks['value'] = function($super) {
                                                                                                        return $label;
                                                                                                    }),
                                                                                                    (__$blocks['value'] = function($super, data) {
                                                                                                        var block = $blocks['value'];
                                                                                                        var callBlock = function() {
                                                                                                            return _$blocks['value'].call($this, $super, data);
                                                                                                        };
                                                                                                        return block ?
                                                                                                            block.call($this, callBlock, data) :
                                                                                                            callBlock();
                                                                                                    }),
                                                                                                    __$blocks['value'](_$no, [value[$key], $label])
                                                                                                )
                                                                                            ), 0, 'k-select-text'),
                                                                                            _$cc(Icon, {
                                                                                                'className': 'ion-ios-close k-select-close',
                                                                                                'ev-click': this.delete.bind(this, $key),
                                                                                                'hoverable': !disabled
                                                                                            })
                                                                                        ], 4, 'k-select-tag', null, isStringOrNumber($label) ? 
                                                                                            $label :
                                                                                            isStringOrNumber(value[$key]) ?
                                                                                                value[$key] :
                                                                                                undefined);
                                                                                    }, $this)
                                                                                );
                                                                            }),
                                                                            (__$blocks['values'] = function($super, data) {
                                                                                var block = $blocks['values'];
                                                                                var callBlock = function() {
                                                                                    return _$blocks['values'].call($this, $super, data);
                                                                                };
                                                                                return block ?
                                                                                    block.call($this, callBlock, data) :
                                                                                    callBlock();
                                                                            }),
                                                                            __$blocks['values'](_$no, [value, label])
                                                                        )
                                                                    )
                                                                )
                                                            }),
                                                            (filterable) ?
                                                                _$cc(Input, {
                                                                    'className': 'k-select-input',
                                                                    'value': keywords,
                                                                    'ev-$change:value': onInput,
                                                                    'disabled': disabled,
                                                                    'placeholder': !hasValue ? placeholder : '',
                                                                    'ref': inputRef,
                                                                    'autoWidth': true,
                                                                    'inline': true,
                                                                    'size': size,
                                                                    'key': 'filter',
                                                                    'readonly': !_show,
                                                                    'waveDisabled': true
                                                                }, 'filter', inputRef) :
                                                                undefined
                                                        ], 0, _$cn({
                                                            "k-select-values": true,
                                                            "k-with-values": $blocks.values,
                                                        }), null, 'values')
                                        )
                                    })
                                ], 0, 'k-select-main'),
                                (!hideIcon || clearable || loading || $blocks.suffix) ?
                                    _$ce(2, 'span', [
                                        (clearable && !disabled) ?
                                            _$cc(Icon, {
                                                'className': _$cn({"k-select-clear ion-ios-close": true, "k-show": hasValue}),
                                                'ev-click': this.clear,
                                                'hoverable': true
                                            }) :
                                            undefined,
                                        _$ce(2, 'span', (
                                            (
                                                (_$blocks['suffix'] = function($super) {
                                                    return (
                                                        (loading) ?
                                                            _$cc(Icon, _$tmp0) :
                                                            !hideIcon ?
                                                                _$cc(Icon, {
                                                                    'className': _$cn({
                                                                        "k-select-arrow ion-ios-arrow-down": true,
                                                                        'k-disabled': $props.isDisableArrow 
                                                                    })
                                                                }) :
                                                                undefined
                                                    );
                                                }),
                                                (__$blocks['suffix'] = function($super, data) {
                                                    var block = $blocks['suffix'];
                                                    var callBlock = function() {
                                                        return _$blocks['suffix'].call($this, $super, data);
                                                    };
                                                    return block ?
                                                        block.call($this, callBlock, data) :
                                                        callBlock();
                                                }),
                                                __$blocks['suffix'](_$no)
                                            )
                                        ), 0, 'k-select-suffix-icon')
                                    ], 0, 'k-select-suffix') :
                                    undefined
                            ]),
                            (
                                (
                                    (_$blocks['base-menu'] = function($super) {
                                        return (
                                            _$ce(2, 'div', 'should be implemeted', 16)
                                        );
                                    }),
                                    (__$blocks['base-menu'] = function($super, data) {
                                        var block = $blocks['base-menu'];
                                        var callBlock = function() {
                                            return _$blocks['base-menu'].call($this, $super, data);
                                        };
                                        return block ?
                                            block.call($this, callBlock, data) :
                                            callBlock();
                                    }),
                                    __$blocks['base-menu'](_$no)
                                )
                            )
                        ],
                        'ev-$model:value': function($v) {
                            $this.set('_show', $v);
                        },
                        'value': $this.get('_show')
                    }, null, this.dropdownRef)
                )
            })
        }
    });
};